import type { EntryTimelineItem } from "@/mocks/entries";

export default function EntryTimeline({ timeline }: { timeline: EntryTimelineItem[] }) {
  return (
    <ol className="relative mt-6 space-y-6 border-l border-background-300 pl-6">
      {timeline.map((item, index) => (
        <li key={`${item.date}-${item.title}`} className="relative">
          <span
            className={`absolute -left-[31px] flex h-5 w-5 items-center justify-center rounded-full border-2 border-background-50 ${
              index === timeline.length - 1 ? "bg-accent-500" : "bg-primary-500"
            }`}
          >
            <span className="h-1.5 w-1.5 rounded-full bg-background-50"></span>
          </span>
          <time className="text-xs font-medium text-secondary-700">{item.date}</time>
          <h3 className="mt-1 text-base font-semibold text-foreground-950">{item.title}</h3>
          <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
        </li>
      ))}
    </ol>
  );
}